@let maxWidth = maxContentWidth() ? maxContentWidth() : undefined;

<div
  class="fr8bot-dialog-small"
  [class.fr8bot-dialog-small--disable-default-width]="disableDefaultWidth()"
>
  @if (showCloseButton()) {
    <button class="dialog__close" (click)="closeDialog.emit()">
      <fr8bot-ui-icon name="menu-x" [size]="16" />
    </button>
  }

  <div class="fr8bot-dialog-small-inner">
    <div class="fr8bot-dialog-small-inner__top" [style.min-height.px]="minContentHeight()">
      <div class="fr8bot-dialog-small-inner-icon">
        <ng-content select="[icon]"></ng-content>
      </div>

      <div class="fr8bot-dialog-small-inner-heading">
        <div class="fr8bot-dialog-small-inner-heading__inner" [style.max-width.px]="maxWidth">
          <div class="fr8bot-dialog-small-inner-heading__inner-main">
            <div class="fr8bot-dialog-small-inner-heading__inner-main-title">
              <ng-content select="[title]"></ng-content>
            </div>

            <div class="fr8bot-dialog-small-inner-heading__inner-main-subtitle">
              <ng-content select="[subtitle]"></ng-content>
            </div>
          </div>

          <div class="fr8bot-dialog-small-inner-heading__description">
            <ng-content select="[description]"></ng-content>
          </div>
        </div>
      </div>

      <div class="fr8bot-dialog-small-inner-main">
        <div class="fr8bot-dialog-small-inner-main__inner" [style.max-width.px]="maxWidth">
          <ng-content></ng-content>
        </div>
      </div>
    </div>

    <div class="fr8bot-dialog-small-inner__bottom">
      <div class="fr8bot-dialog-small-inner-actions">
        <div class="fr8bot-dialog-small-inner-actions__inner" [style.max-width.px]="maxWidth">
          <ng-content select="[actions]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
